import { normalizeLinkNodePath } from './linkNodePath';

/**
 * Legacy predefined `?t=<target>` aliases from the PopshopRN bio. React Native's
 * navigator couldn't preserve URL fragments, so interior links were carried as a
 * `?t=` query param with these two shorthands; everything else was the raw tree
 * path.
 */
const LEGACY_TARGET_ALIAS: Record<string, string> = {
  life: 'my-life',
  store: 'my-store',
};

/**
 * Adapt a legacy interior-link target (a `?t=` value, or a stored `fullPath`) to
 * the canonical link node path used by the fragment-based linking module. Maps
 * the `life` / `store` shorthands and strips a leading slash; any other value
 * passes through normalized. Returns undefined for an empty target.
 */
export function legacyLinkTargetToPath(value: string): string | undefined {
  const trimmed = value.trim();
  if (trimmed.length === 0) {
    return undefined;
  }
  const normalized = normalizeLinkNodePath(trimmed);
  return LEGACY_TARGET_ALIAS[normalized] ?? normalized;
}
